/**
 * JWT 工具类
 * 用于在前端解码 JWT Token 并验证其是否过期
 */

/**
 * 解码 JWT Token 获取 payload 数据
 * @param {string} token - JWT Token
 * @returns {object|null} - 解析后的 payload 或 null
 */
export const decodeToken = (token) => {
  try {
    if (!token || typeof token !== 'string') return null;
    
    // JWT 有三部分：header, payload, signature
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // 解析 payload（第二部分）
    const base64Url = parts[1];
    // 将 Base64Url 转换为 Base64
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    
    // 解码 Base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('解析 Token 失败:', error);
    return null;
  }
};

/**
 * 检查 Token 是否已过期
 * @param {string} token - JWT Token
 * @returns {boolean} - true 表示已过期或无效，false 表示有效
 */
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  
  // exp 是以秒为单位的 Unix 时间戳，Date.now() 是毫秒
  const currentTime = Math.floor(Date.now() / 1000);
  
  // 预留 10 秒的缓冲时间，防止由于客户端与服务器时钟细微差异导致的边界问题
  return decoded.exp < (currentTime + 10);
};
